import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import createRootReducer from '../reducers';
import { createMiddleware, persistenceMiddleware } from '../fsm/machine';

const configureStore = (initialState, machine) => {
  const middlewares = machine ? [createMiddleware(machine), persistenceMiddleware(machine), thunk] : [thunk];
  return createStore(createRootReducer(machine), initialState, composeWithDevTools(applyMiddleware(...middlewares)));
};

export default configureStore;
